import React, { useEffect, useContext } from 'react'
import { Dropdown } from 'components/ui'
import ModeSwitcher from 'components/template/ThemeConfigurator/ModeSwitcher'
import withHeaderItem from 'utils/hoc/withHeaderItem'
import { Link, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { HiOutlineUser, HiOutlineLogout, HiOutlineCog } from 'react-icons/hi'
import { FaPatreon } from 'react-icons/fa'
import { PatreonUserContext } from './PatreonUser'

const CLIENT_ID = 'PZrCt6X3UjCf6x6g6fqkQNLROJKPxj9cwXh84drMS2-rl7iHvedqmdQUm90bRTiG';
const REDIRECT_URI = 'https://labmaus.net/patreon_callback';

export const UserDropdown = ({ className }) => {
    const { patreonUser, setPatreonUser } = useContext(PatreonUserContext);
    const navigate = useNavigate();

    const handleSignOut = () => {
        // Clear user data from localStorage and state
        localStorage.removeItem('patreon_user');
        setPatreonUser(null);
        navigate('/tournaments');
    };

    const dropdownItemList = [
        {
            label: 'Tournaments',
            path: '/app/account/settings/profile',
            icon: <HiOutlineUser />,
            visible: patreonUser && (patreonUser.tier_id === '9748219' || patreonUser.tier_id === '9748228') ? true : false
        },
        {
            label: 'Connect to Patreon',
            path: `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=identity`,
            icon: <FaPatreon />,
            visible: patreonUser ? false : true
        },
        {
            label: 'Sign Out',
            onClick: handleSignOut,
            icon: <HiOutlineLogout />,
            visible: patreonUser ? true : false
        }
    ]
    
    useEffect(() => {
        // Function to handle the OAuth callback
        const handlePatreonCallback = async () => {
            const urlParams = new URLSearchParams(window.location.search)
            const code = urlParams.get('code')
            if (code) {
                try {
                    const response = await fetch(`https://labmaus-website-b7a5f5f01a05.herokuapp.com/auth/patreon/callback?code=${code}`)
                    const userData = await response.json()
                    
                    if (response.ok) {
                        // Save user data to state and localStorage
                        setPatreonUser(userData)
                        localStorage.setItem('patreon_user', JSON.stringify(userData))
                        
                        // Redirect to the /tournaments page
                        navigate('/tournaments');
                    } else {
                        console.error('Failed to authenticate with Patreon:', userData)
                    }
                } catch (error) {
                    console.error('Error handling Patreon callback:', error)
                }
            }
        }

        // Run the callback handler if the code is present in the URL
        if (window.location.pathname === '/patreon_callback') {
            handlePatreonCallback()
        }
    }, [navigate, setPatreonUser])

    useEffect(() => {
        // Load user data from localStorage if available
        const storedUserData = localStorage.getItem('patreon_user')
        if (storedUserData) {
            setPatreonUser(JSON.parse(storedUserData))
        }
    }, [setPatreonUser])

    const SettingsCog = (
        <div className={classNames('text-2xl', className)}>
            <HiOutlineCog />
        </div>
    )

    return (
        <div>
            <Dropdown
                menuStyle={{ minWidth: 200 }}
                renderTitle={SettingsCog}
                placement="bottom-end"
            >
                {patreonUser && (
                    <>
                        <Dropdown.Item variant="header">
                            <div className="py-2 px-3 flex items-center gap-2">
                                <div>
                                    <div className="font-bold text-gray-900 dark:text-gray-100">
                                        {patreonUser.user_name}
                                    </div>
                                    <div className="text-xs">{patreonUser.tier_name}</div>
                                </div>
                            </div>
                        </Dropdown.Item>
                        <Dropdown.Item variant="divider" />
                    </>
                )}
                <Dropdown.Item>
                    <div className="py-1 px-3 flex items-center gap-2">
                        <span>Dark Mode</span>
                        <div className="px-3">
                            <ModeSwitcher />
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item variant="divider" />
                {dropdownItemList.map((item) => item.visible && (
                    <Dropdown.Item
                        eventKey={item.label}
                        key={item.label}
                        className="mb-1"
                        onClick={item.onClick}
                    >
                        {item.path ? (
                            <Link
                                className="flex gap-2 items-center"
                                to={item.path}
                            >
                                <span className="text-xl opacity-50">
                                    {item.icon}
                                </span>
                                <span>{item.label}</span>
                            </Link>
                        ) : (
                            <div className="flex gap-2 items-center">
                                <span className="text-xl opacity-50">
                                    {item.icon}
                                </span>
                                <span>{item.label}</span>
                            </div>
                        )}
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </div>
    )
}

export default withHeaderItem(UserDropdown)
